import { RootState } from "domain/store";

export const selectIsAIFeedbackToastOpen = (state: RootState) => {
  return state.aiSearch.isAIFeedbackToastOpen;
};

export const selectIsAIFeedbackLoading = (state: RootState) => {
  return state.aiSearch.isAIFeedbackLoading;
};

export const selectAIToastStep = (state: RootState) => {
  return state.aiSearch.toastStep;
};

export const selectIsSearchingTechnique = (state: RootState) => {
  return !!state.aiSearch.techniqueFeedback.request;
};

export const selectTechniquesFromAISearch = (state: RootState) => {
  return state.aiSearch.techniqueAISearchResults;
};

export const selectIsAISearchLoading = (state: RootState) => {
  return state.aiSearch.isAISearchLoading;
};

export const selectFeedbackRequest = (state: RootState) => {
  return state.aiSearch.techniqueFeedback.request;
};
